export default __webpack_public_path__ + "static/media/How_Its_Made_640x910-compressed.6e2a91ce.mp4";